import React from 'react';
interface imageProps{
  source:string,
  height?:number,
  width?:number,
  mode?:any,
  style?:object
}
const ImageComponent = ({ source, height, width, mode, style }: imageProps) => {
  return (
    <div
      style={{
        height: height ? `${height}rem` : '100%',
        width: width ? `${width}rem` : '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      className="h-full w-full flex items-center justify-center"
    >
      <img
        src={source}
        alt="image"
        style={{
          height: '100%',
          width: '100%',
          objectFit: mode || 'contain',
          ...style,
        }}
        className="h-full w-full"
      />
    </div>
  );
};

export default ImageComponent;